import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  StyledTextArea,
  type StyledTextAreaProps,
} from '~/components/elements/StyledTextArea'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

export type HowInputProps = {
  index: number
}

export const HowInput = ({ index }: HowInputProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const howField = useFormField(control, `strategies.${index}.how`)

  const logEvent = useLogEvent()
  const handleBlur = React.useCallback<
    EH<StyledTextAreaProps, 'onBlur'>
  >(() => {
    howField.onBlur()
    logEvent('Edit HOW')
  }, [howField, logEvent])

  return (
    <LabelingContainer label={t('how')}>
      <StyledTextArea
        autoSize={true}
        rows={1}
        width="100%"
        {...howField}
        onBlur={handleBlur}
      />
    </LabelingContainer>
  )
}
